import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

export const classNames = (...args: Parameters<typeof clsx>) => twMerge(clsx(args))
